"use client";

import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from "react";
import BrainMobile from "../brain/BrainMobile";
import { SidebarProvider } from "../../hooks/useSidebarState";
import { ContentTabProvider } from "../brain/ContentTabContext";
interface Props {
  readonly children: ReactNode;
}

// For now, reuse the existing BrainMobile until we create message-specific mobile components
const MessagesMobile: React.FC<Props> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <SidebarProvider><ContentTabProvider><BrainMobile>{children}</BrainMobile></ContentTabProvider></SidebarProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MessagesMobile;